import axios from "axios";
export const state = {
    branch: [],
    branch_state:false,
};
export const getters = {
    GetBranch: state => state.branch.data,
    BranchState: state => state.branch_state,

};

export const mutations = {
    SET_BRANCH(state, newValue) {
        state.branch = newValue
    },
    SET_BRANCH_STATE(state, newValue) {
        state.branch_state = newValue
    },
};

export const actions = {
    
    fetchBranch({ commit, dispatch }) {
        axios.get('clinic_branch').then(res => {
            commit('SET_BRANCH', res.data)
        }).catch(() => {
            let message = { 'msg': "Error in fetching branches" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // add Cashin
    addBranch({ commit, dispatch }, payload) {
        commit('SET_BRANCH_STATE', true)
        axios.post('clinic_branch', payload).then(() => {
            dispatch('fetchBranch');
            let message = { 'msg': "Branch registered successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_BRANCH_STATE', false)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_BRANCH_STATE', false)
            let message = { 'msg': "Error Adding Branch" }
            dispatch('notification/error', message, { root: true })

        })
    },


    // Edit Cashin
    editBranch({ commit, dispatch }, payload) {
        commit('SET_BRANCH_STATE', true);        
        axios.put(`clinic_branch/${payload.id}`, payload).then(() => {
            dispatch('fetchBranch');
            let message = { 'msg': "Branch record updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_BRANCH_STATE', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_BRANCH_STATE', false)
            let message = { 'msg': "Error updating Branch record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete expense 
    deleteBranch({ commit, dispatch }, payload) {
        commit('SET_BRANCH_STATE', true);
        axios.delete(`clinic_branch/${payload.id}`).then(() => {
            dispatch('fetchBranch');
            let message = { 'msg': "Branch in deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_BRANCH_STATE', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_BRANCH_STATE', false)
            let message = { 'msg': "Error Deleting Branch" }
            dispatch('notification/error', message, { root: true })
        })
    },

   
};